import { Component, Input } from '@angular/core';
import { AuthService, DatasourceService } from '@app/core/services';
import { BaseListComponent } from './base-list.component';
import { State, aggregateBy, AggregateResult } from "@progress/kendo-data-query";
import { IntlService } from '@progress/kendo-angular-intl';


@Component({
  selector: 'expenses-list',
  template: `
  <kendo-grid #grid [style.height.%]="100" [data]="view | async">
  
    <ng-template kendoGridNoRecordsTemplate>
      Sin registros.
    </ng-template>

    <kendo-grid-column field="n" title="#" width="60" [filterable]="false">
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
        # {{rowIndex + 1}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="date" title="Fecha" width="120" *ngIf="view_date">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
        <kendo-grid-cell-date [text]="dataItem.date" [time]="false"></kendo-grid-cell-date>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="description" title="Descripción"></kendo-grid-column>
    <kendo-grid-column field="expense_type_name" title="Tipo de gasto" width="250"></kendo-grid-column>
    <kendo-grid-column field="supplier" title="Proveedor" width="250"></kendo-grid-column>    
    <!--<kendo-grid-column field="payment_type_name" title="Tipo de pago" width="150"></kendo-grid-column>-->
    <kendo-grid-column field="person_authorize_name" title="Autoriza" width="250">
      <ng-template kendoGridFooterTemplate>
        <div style="text-align: right;">Total</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="cost" title="Costo" width="120" format="{0:c}" [style]="{'text-align': 'right'}">
      <ng-template kendoGridFooterTemplate>
        <div style="text-align: right;">{{intl.formatNumber(total?.cost?.sum, 'c2')}}</div>
      </ng-template>
    </kendo-grid-column>      

  </kendo-grid>
  `,
  styles: [``],
  providers:  [ DatasourceService ]
})
export class ExpensesListComponent extends BaseListComponent {

  //Variables

  protected table: string = 'expenses_inventories';

  //Input: range
  public _range = { start: '', end: '' };

  @Input()
  set range(range: any) {
    this._range = range;
    
    let that = this;
    this.state = this.getInitialState();    
    this.service.pagination(this.table, this.state, function(result, table, state){
      console.log(result, table, state);
      // that.visible = result.data.length;
      that.total = aggregateBy(result.data, [
        { field: "cost", aggregate: "sum" }
      ]);  
      
      if(Object.keys(that.total).length === 0) 
        that.total = {cost: {sum: 0}};

      that.resultChange.emit({name: `EXPENSES_${that.payment_type}`, result: result, sum: that.total.cost.sum});

    });
  }

  get range(): any { return this._range; }

  @Input() payment_type: string = '';

  @Input() view_date: boolean = true;

  public total: AggregateResult;  

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected intl: IntlService) {

    super(authService, service, intl);
    console.log(this.range);

  }

  //Overrides
  protected getInitialState() : State {

    let s : State = {
      skip: 0, 
      take: 0, 
      sort: [      
        {field: 'date', dir: 'desc'}
      ], 
      filter: {
        logic: "and",
        filters: [                
          {
            field: 'date',
            operator: 'inrange',
            value: `${this._range.start} 00:00:00,${this._range.end} 23:59:59`
          },
          {
            field: 'id_payment_type',
            operator: 'in',
            value: this.payment_type
          }
        ]
      }, 
      group: []
    }

    return s;

  }
  
}
